// Kadence kan rijachtergronden via gegenereerde CSS instellen, zonder paletclass.
function initCornerBackgrounds() {
 const corners = [...document.querySelectorAll('.iml-blocks-left-top, .iml-blocks-right-top, .iml-blocks-left-bottom, .iml-blocks-right-bottom')];
 const update = () => {
  corners.forEach(corner => {
   const row = corner.parentElement?.closest('.kb-row-layout-wrap');
   if (!row) return;
   const color = getComputedStyle(row).backgroundColor;
   if (corner.style.getPropertyValue('--iml-corner-parent-background') !== color) {
    corner.style.setProperty('--iml-corner-parent-background', color);
   }
  });
 };
 update();
 window.addEventListener('load', update, { once: true });
 window.addEventListener('resize', update);
 const observer = new MutationObserver(update);
 const rows = new Set(corners.map(corner => corner.parentElement?.closest('.kb-row-layout-wrap')).filter(Boolean));
 rows.forEach(row => observer.observe(row, { attributes: true, attributeFilter: ['class', 'style'] }));
}

if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', initCornerBackgrounds, { once: true });
} else {
 initCornerBackgrounds();
}
